import React from "react";
import { FormControl, InputLabel, Select, MenuItem, Box, Typography, useTheme } from "@mui/material";
import { formatDate } from "../../../../../utils/dateUtils";

const AssessmentDropdown = ({ 
  assessments, 
  selectedAssessmentIdx, 
  onAssessmentChange, 
  currentSystem 
}) => {
  const theme = useTheme();

  return (
    <FormControl sx={{ minWidth: 320, mb: 2 }} size="small">
      <InputLabel id="assessment-select-label">
        Select Assessment
      </InputLabel>
      <Select
        labelId="assessment-select-label"
        value={selectedAssessmentIdx}
        label="Select Assessment"
        onChange={(e) => onAssessmentChange(e.target.value)}
      >
        {assessments.map((a, idx) => (
          <MenuItem key={a?.id || idx} value={idx}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                width: "100%",
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  color: theme.customColors?.text?.strong || "#111827",
                }}
              >
                {a?.system_name || currentSystem?.label || "Unknown System"} -{" "}
                {a?.title} - {formatDate(a?.created_at)}
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  color: theme.customColors?.text?.secondary || "#6B7280",
                }}
              >
                {a?.status_title}
              </Typography>
            </Box>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default AssessmentDropdown;

